import { appendIf } from '@btime/helpers'
import { useTranslation } from 'react-i18next'

import {
  useChecklistCloneAction,
  useChecklistDetailsAction,
  useChecklistEditAction,
  useChecklistLogsActions,
  useChecklistRemoveAction,
  useChecklistSaveAsTemplateAction,
  useChecklistSimulationAction,
  useChecklistsLogsAction,
  useChecklistsRemoveAction
} from './actions'
import { useColors } from '../../../packages/kiti/components/theme/_hooks/colors'

const useSingleActions = (item, opts) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []
  const colors = useColors()

  const details = useChecklistDetailsAction(item)
  const log = useChecklistLogsActions(item)
  const simulation = useChecklistSimulationAction(item)
  const clone = useChecklistCloneAction(item)
  const saveAsTemplate = useChecklistSaveAsTemplateAction(item)
  const edit = useChecklistEditAction(item)
  const remove = useChecklistRemoveAction(item)

  return [
    ...appendIf(!hide.includes('seeDetails'), {
      value: t('seeDetails'),
      icon: 'RiSearchLine',
      onClick: details.click
    }),

    ...appendIf(log.hasPermission, {
      value: t('logs'),
      icon: 'RiTimeLine',
      onClick: log.click,
      to: log.link
    }),

    ...appendIf(!hide.includes('simulation'), {
      value: t('simulation'),
      icon: 'RiPlayCircleLine',
      onClick: simulation.click
    }),

    ...appendIf(!hide.includes('seeDetails') && clone.hasPermission, {
      value: t('clone'),
      icon: 'RiFileCopy2Line',
      onClick: clone.click
    }),

    ...appendIf(!hide.includes('seeDetails') && saveAsTemplate.hasPermission, {
      value: t('saveAsTemplate'),
      icon: 'RiDatabase2Line',
      onClick: saveAsTemplate.click
    }),

    ...appendIf(edit.hasPermission, {
      value: t('edit'),
      icon: 'RiPencilLine',
      onClick: edit.click,
      to: edit.link
    }),

    ...appendIf(remove.hasPermission, {
      value: t('remove'),
      color: colors.red,
      icon: 'RiDeleteBin2Line',
      onClick: remove.click
    })
  ]
}

const useMultiActions = (items, opts) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []
  const colors = useColors()

  const logs = useChecklistsLogsAction(items)
  const remove = useChecklistsRemoveAction(items)

  return [
    ...appendIf(logs.hasPermission, {
      value: t('logs'),
      icon: 'RiTimeLine',
      onClick: logs.click,
      to: logs.link
    }),

    ...appendIf(remove.hasPermission, {
      value: t('remove'),
      color: colors.red,
      icon: 'BsTrash',
      onClick: remove.click
    })
  ]
}

export const useChecklistActionsList = (item, items, opts = {}) => {
  const singleOptions = useSingleActions(item, opts)
  const multiOptions = useMultiActions(items, opts)

  return [!items || items.length === 1 ? singleOptions : multiOptions, false]
}
